import {DataSetWorkMode} from "./rdf-data-set";

/**
 * Класс generic для паджинирования данных в.
 * В класс передается массив типа Т, и метод позволяет двинаться по нему вперед и назад по странично, или работать как с бесконечным списком
 */
export class RdfMemoryDataSet<T> {
  rawData: Array<T> = [];
  filteredData: Array<T> = [];
  data: Array<T> = [];

  private searchStr = '';

  offset = 0;
  constructor(
    private workMode: DataSetWorkMode = 'page',
    private limit = 100,
    private searchFields: Array<string> = []
  ) {
  }

  /**
   * Получить данные
   * @param rawData сырые данные
   * @param searchStr строка поиска
   * @param offset смещение
   */
  fetch(rawData: Array<T>, searchStr: string ='', offset?:number ): Array<T> {
    this.data = [];
    this.rawData = rawData;
    this.searchStr = searchStr;
    this.offset = offset?offset:0;
    if (this.workMode === 'list') {
      this.offset = 0;
    }
    this.filteredData = this.filterDataSet(this.rawData);
    this.data = this.filteredData.slice(this.offset, this.offset + this.limit);

    return this.data;
  }

  /**
   * Сдвинуться вперед
   */
  next(): Array<T> {
    if (this.offset + this.limit< this.filteredData.length) {
      this.offset += this.limit;
    }
    switch (this.workMode) {
      case "page":
        return this.filteredData.slice(this.offset, this.offset + this.limit);
      case "list":
        return this.filteredData.slice(0, this.offset + this.limit);

    }

  }

  /**
   * Сдвинуться назад
   */
  prev():Array<T>{
    this.offset -= this.limit;
    if (this.offset<0){
      this.offset = 0;
    }
    switch (this.workMode) {
      case "page":
        return this.filteredData.slice(this.offset, this.offset + this.limit);
      case "list":
        return this.filteredData.slice(0, this.offset + this.limit);
    }
  }
  private filterDataSet(data:Array<T>):Array<T>{
    if (!data) return [];
    return data.filter(t=> {
      let result = false;
      if (!this.searchStr || this.searchFields.length === 0) {
        return true;
      }
      const s1 = this.searchStr.toLocaleLowerCase();
      this.searchFields.forEach(field =>{
        const value = t[field];
        if (value!==null && value!==undefined) {
          const s2 = value
            .toString()
            .toLocaleLowerCase()
            .replace(' ','');
          if (s2.indexOf(s1)>-1) {
            result = true;
          }
        }
      });
      return result;
    });
  }

  /**
   * Есть ли данные дальше?
   */
  isNextDataPresent():boolean{
    if (this.filteredData.length ===0){
      return false;
    }
    if (this.filteredData.length<(this.offset + this.limit)) {
      return false;
    }
    return true;
  }
}
